var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgManage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "2 1 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UserCircleGear",
    clipPath: "url(#clip0_2166_1818)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M23.6816 8.4375C24.7172 8.4375 25.5566 7.59803 25.5566 6.5625C25.5566 5.52697 24.7172 4.6875 23.6816 4.6875C22.6461 4.6875 21.8066 5.52697 21.8066 6.5625C21.8066 7.59803 22.6461 8.4375 23.6816 8.4375Z",
    stroke: "#D3D3D3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M23.6816 4.6875V3.28125",
    stroke: "#D3D3D3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M22.0574 5.625L20.8398 4.92188",
    stroke: "#D3D3D3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M22.0574 7.5L20.8398 8.20312",
    stroke: "#D3D3D3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M23.6816 8.4375V9.84375",
    stroke: "#D3D3D3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M25.3066 7.5L26.5242 8.20312",
    stroke: "#D3D3D3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M25.3066 5.625L26.5242 4.92188",
    stroke: "#D3D3D3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M15.2441 17.8125C17.833 17.8125 19.9316 15.7138 19.9316 13.125C19.9316 10.5362 17.833 8.4375 15.2441 8.4375C12.6553 8.4375 10.5566 10.5362 10.5566 13.125C10.5566 15.7138 12.6553 17.8125 15.2441 17.8125Z",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M8.00586 24.3008C8.35783 22.9928 9.50242 21.7446 10.8304 20.9295C12.1583 20.1144 13.686 19.6829 15.2442 19.6829C16.8023 19.6829 18.3301 20.1144 19.658 20.9295C20.986 21.7446 22.0728 22.833 22.4885 24.3008",
    fill: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M26.339 13.125C26.7346 15.475 26.373 17.8899 25.3065 20.021C24.24 22.1521 22.5238 23.8892 20.4058 24.9813C18.2877 26.0734 15.8773 26.4641 13.5227 26.097C11.1681 25.7299 8.99107 24.624 7.30599 22.9389C5.62091 21.2538 4.51497 19.0768 4.14786 16.7222C3.78075 14.3676 4.17147 11.9572 5.2636 9.83914C6.35574 7.72106 8.09276 6.00489 10.2239 4.93841C12.355 3.87193 14.7699 3.51035 17.1199 3.90586",
    stroke: "#D3D3D3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 39",
    d: "M21.5881 23.6362H8.58398L11.8978 25.631L15.3539 26.1655L18.5605 25.631L20.6983 24.7759L21.5881 23.6362Z",
    fill: "#D3D3D3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2166_1818"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(0.244141)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgManage);
export default __webpack_public_path__ + "static/media/manage.9cc8bf367cb695938dac9735c8524947.svg";
export { ForwardRef as ReactComponent };